import React from 'react';
import { Formik } from "formik";
import SchemaSorteos from './schemaSorteo';

export default function AddSorteo(props) {
    const { Save, Singles } = props;
    return (
        <Formik
            initialValues={Singles.id == '' ? {
                id:0,
                nombre: '',
                fecha_inicio: moment().format('YYYY-MM-DD'),
                fecha_fin: moment().format('YYYY-MM-DD'),
                hora_fin: '',
                multiple: false
            } : Singles}
            validationSchema={SchemaSorteos}
            enableReinitialize="true"
            onSubmit={(values, actions) => {

                
                //alert("pass");
                Save(values, actions);
                //AddUser(values,actions);
                //console.log('actions', actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <div className="modal" id="addSorteo" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Añadir nuevo sorteo</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-8 col-lg-8">
                                            <div className={errors.nombre ? "form-group has-error" : "form-group"}>
                                                <label htmlFor="exampleInputEmail1">Nombre:</label>
                                                <input type="text" onChange={handleChange} value={values.nombre || ""} className={errors.nombre ? "form-control has-error" : "form-control"} name="nombre" id="nombre" autoComplete="none" />
                                                <span className="help-block">{errors.nombre}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4 col-lg-4" style={{ paddingTop: "5vh" }}>
                                            <div className={errors.multiple ? "form-check has-error" : "form-check"}>
                                                <input className="form-check-input" type="checkbox" value={values.multiple || ""} id="multiple" name="multiple" onChange={() => setFieldValue("multiple", !values.multiple)} checked={values.multiple} />
                                                <label className="form-check-label">
                                                    Segundo lugar
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Fecha inicio:</label>
                                                <input type="date" className={errors.fecha_inicio ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.fecha_inicio || ""} name="fecha_inicio" id="fecha_inicio" autoComplete="none" />
                                                <span className="help-block">{errors.fecha_inicio}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Fecha fin:</label>
                                                <input type="date" className={errors.fecha_fin ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.fecha_fin || ""} name="fecha_fin" id="fecha_fin" autoComplete="none" />
                                                <span className="help-block">{errors.fecha_fin}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Hora fin:</label>
                                                <input type="time" className={errors.hora_fin ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.hora_fin || ""} name="hora_fin" id="hora_fin" autoComplete="none" />
                                                <span className="help-block">{errors.hora_fin}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => () => resetForm()} >Cancelar</button>
                                    <button type='submit' className="btn text-white" style={{ background: "#E6453B" }}>Guardar</button>
                                    {/*  <button onClick={()=>console.log("estado",values)}>check state</button> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
